import { Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useGetPatientInfo } from 'modules/report/hooks/usePatientInfo';
import styled from 'styled-components';

export const HypoglycemiaList = (props) => {
  const { total, level1, level2, nocturnal } =
    props !== {} && props?.HypoglycemiaListData;
  const { data: patientInfo } = useGetPatientInfo(props?.patientId);
  const { isPregnant } = patientInfo || {};

  const data = [
    {
      labelBold: 'Total ',
      label: 'number of hypoglycemia events ',
      value: total ? total : '_'
    },
    {
      labelBold: 'Level 1 ',
      label: `hypoglycemia (54 &le; BS < ${isPregnant ? 60 : 70}) `,
      value: level1 ? level1 : '_'
    },
    {
      labelBold: 'Level 2 ',
      label: 'hypoglycemia (BS < 54) ',
      value: level2 ? level2 : '_'
    },
    {
      labelBold: 'Nocturnal ',
      label: 'hypoglycemia events ',
      value: nocturnal ? nocturnal : '_'
    }
  ];
  const LineSeparator = () => {
    return (
      <Divider
        sx={{
          borderColor: { md: '#EBEBEB' },
          margin: 'auto',
          width: '100%',
          height: '0.5px',
          background: '#FFFFFF',
          margin: '7px 0 14px'
        }}
      />
    );
  };

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }

  return (
    <Grid
      container
      sx={{
        padding: { xs: '8px 31px 16px 16px', md: '48px 64px 64px' }
      }}
    >
      <StyledHypoList>
        <p className="list-title">Hypoglycemia Events:</p>
        {data.map(({ labelBold, label, value }, index) => (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            key={label}
          >
            <Grid item xs={1.5}>
              <span className="list-value">{value}</span>
            </Grid>
            <Grid item xs={10.5} textAlign="left" dir="ltr">
              <span style={{ fontFamily: 'dana-bold' }} className="list-label">
                {labelBold}
              </span>
              <span className="list-label">{htmlDecode(label)}:</span>
            </Grid>
            {index !== 3 && <LineSeparator />}
          </Grid>
        ))}
      </StyledHypoList>
    </Grid>
  );
};

const StyledHypoList = styled.div`
  width: 100%;
  .list-label {
    font-size: 13.7px;
    font-weight: 400;
    line-height: 21px;
    color: #1f2937;
    width: 100%;
  }
  .list-value {
    font-size: 18px;
    font-family: 'dana-bold';
    line-height: 28px;
    text-align: right;
    color: #6f4d9f;
  }
  .list-title {
    color: #d81d5d;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
    direction: ltr;
    width: 100%;
    padding: 8px 16px 19px 16px;
  }

  @media screen and (min-width: 1024px) {
    .list-label,
    .list-value {
      font-size: 24px;
      line-height: 37px;
    }
    .list-title {
      font-size: 28px;
      padding: 32px 0 48px;
    }
  }
`;
